import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { PollTemplate, RecurrenceType } from "./create-poll/create-poll.type";
import { PollList, PollListItem, PollTrends } from "./user-polls/user-polls.type";
import { PollTemplateForPreview, TemplateBank, TemplateListByTopic } from "./poll-templates/poll-templates.type";
import { PollDetails } from "./user-polls/poll-results-dialog/poll-results-dialog.component";


@Injectable(
    {
        providedIn: 'root'
    }
)
export class PollSetupService {
    constructor(
        private http: HttpClient,
    ){}

    all(): Observable<PollList> {
        return this.http.get<PollList>('/api/question/all');
    }

    getPollDetails(pollOccurrenceId: string) {
        return this.http.post<PollDetails>(`/api/question/details/`, {pollOccurrenceId: pollOccurrenceId});
    }

    getPollTrend(pollAggregateId: string) {
        return this.http.post<PollTrends>(`/api/question/trend/`, {pollAggregateId: pollAggregateId});
    }

    deletePoll(pollOccurrenceId: string): Observable<PollList> {
        return this.http.post<PollList>('/api/question/delete', {pollOccurrenceId: pollOccurrenceId});
    }

    sendPollReminder(pollIds: string[]): Observable<PollList> {
        return this.http.post<PollList>('/api/question/remind', {pollIds: pollIds});
    }

    updatePollRecurrence(poll: PollListItem, isRecurring: boolean): Observable<PollList> {
        return this.http.post<PollList>('/api/question/recurrence', {pollAggregateId: poll.id, isRecurring: isRecurring});
    }

    getTemplateBank(): Observable<TemplateBank> {
         return this.http.get<{title: string, description: string, templates: PollTemplate[]}[]>('/api/question/templateBank')
             .pipe(
                 map(topics => {
                     const templateListByTopics = topics.map(topic => {
                         const templates = topic.templates.map(tp => new PollTemplateForPreview(tp));
                         return new TemplateListByTopic(topic.title, topic.description, templates);
                     });
                     return new TemplateBank(templateListByTopics);
                 })
             )
    }

    makePollRecurrent(pollListItemId: string, frequency: RecurrenceType, duration: number) {
        return this.http.post<PollList>('/api/question/makeRecurrent', {pollAggregateId: pollListItemId, frequency: frequency, duration: duration});
    }
}

